// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Nivpv","largestCol":"styles_largestCol__3CjuU","smallestCol":"styles_smallestCol__hdIau"};